import { defineMessages } from "react-intl";

export const COMMON_MESSAGES = defineMessages({
  yesLabel: { id: "funding-application:Yes", defaultMessage: "Yes" },
  noLabel: { id: "funding-application:No", defaultMessage: "No" },
  continueLabel: { id: "funding-application:Continue", defaultMessage: "Continue" },
  doneLabel: { id: "funding-application:Done", defaultMessage: "Done" },
  backLabel: { id: "funding-application:Back", defaultMessage: "Back" },
  select: { id: "funding-application:select", defaultMessage: "Select" },
  nextLabel: {
    id: "funding-application: default next label",
    defaultMessage: "Next",
  },
  goBackLabel: {
    id: "funding-application: back to previous step label",
    defaultMessage: "Go back",
  },
  skipLabel: {
    id: "funding-application: skip to next step label",
    defaultMessage: "Skip",
  },
  addAnother: {
    id: "funding-application: add another",
    defaultMessage: "Add another",
  },
  addADifferentPlatform: {
    id: "funding-application: add a different platform",
    defaultMessage: "Add a different platform",
  },
  documentUploadSusa: {
    id: "funding-application: SUSA document name",
    defaultMessage: "SUSA",
  },
  documentUploadPoolBancario: {
    id: "funding-application: Pool Bancario document name",
    defaultMessage: "Pool bancario",
  },
  documentUploadRevenueForecast: {
    id: "funding-application: revenue projections document name",
    defaultMessage: "Revenue Projections",
  },
  documentUploadDebtAgreement: {
    id: "funding-application: debt agreement document name",
    defaultMessage: "Debt agreements",
  },
  documentUploadPurchaseOrder: {
    id: "funding-application: purchase orders document name",
    defaultMessage: "Purchase orders",
  },
  documentUploadManagementAccounts: {
    id: "funding-application: management accounts document name",
    defaultMessage: "Management accounts",
  },
  documentUploadProfitAndLoss: {
    id: "funding-application: profit and loss document name",
    defaultMessage: "Profit and Loss Statement",
  },
  documentUploadBalanceSheet: {
    id: "funding-application: balance sheet document name",
    defaultMessage: "Balance Sheet",
  },
  connected: {
    id: "funding-application: connected",
    defaultMessage: "Connected",
  },
  added: {
    id: "funding-application: added",
    defaultMessage: "Added",
  },
  connect: { id: "funding-application:connect", defaultMessage: "Connect" },
  uploaded: { id: "funding-application:uploaded", defaultMessage: "Uploaded" },
  upload: { id: "funding-application:upload", defaultMessage: "Upload" },
  submitLabel: { id: "funding-application: submit label", defaultMessage: "Submit" },
  dataSecurityStatement: {
    id: "funding-application: data security statement",
    defaultMessage: "Your data is securely stored in encrypted databases",
  },
  viewOurPrivacyNotice: {
    id: "funding-application: view our privacy notice link",
    defaultMessage: "View our Privacy notice",
  },
  periodText: {
    id: "funding-application: period text",
    defaultMessage: "{dateFrom} to {dateTo}",
  },
  showMoreLabel: {
    id: "funding-application: show more label",
    defaultMessage: "Show more",
  },
  showLessLabel: {
    id: "funding-application: show less label",
    defaultMessage: "Show less",
  },
  iDontSeeMyPlatformListed: {
    id: "funding-application: i dont see my platform listed",
    defaultMessage: "None of the listed platforms",
  },
  pleaseFillOutThisField: {
    id: "funding-application: please fill out this field",
    defaultMessage: "Please fill out this field.",
  },
  verify: { id: "funding-application:verify", defaultMessage: "Verify" },
  needsVerification: { id: "funding-application: needs verification", defaultMessage: "Needs verification" },
  verified: { id: "funding-application:verified", defaultMessage: "Verified" },
  confirm: { id: "funding-application:confirm", defaultMessage: "Confirm" },
});
